const ENVIAR_EMAIL = 'ENVIAR_EMAIL';

export {ENVIAR_EMAIL}
